import axios from 'axios';
import Token from '@/utils/Token';
import { atalho } from '@/utils/Tenant';

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Repassa o atalho `?d=` da URL para as chamadas de API.
 *
 * Sem isto o atalho só pintaria a tela de login: o endereço do navegador tem o
 * parâmetro, mas as requisições da SPA saem sem ele, e o back-end continua
 * resolvendo pelo tenant ativo do usuário.
 *
 * Quem decide se vale é o servidor — `ResolveTenantAtivo` ignora o pedido se o
 * usuário não tiver permissão no tenant. Aqui é só transporte.
 */
if (atalho) {
    window.axios.interceptors.request.use((config) => {
        config.params = { d: atalho, ...(config.params || {}) };

        return config;
    });
}

window.axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if(error.response) {
            if (error.response.status === 401) {
                Token.remove();
                // this.$router.push({ name: 'login' });
                window.location.replace("/login?error=auth");
                return Promise.resolve({});
            } else if(error.response.status === 405) {
                error.message = "Você não tem permissão para executar esta operação.";
            }
        } 
        return Promise.reject(error);
    },
);
